import { all, fork } from "redux-saga/effects";

export function* rootSaga() {}

export default rootSaga;
